<template>
    <div class="container">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Lista de Sinistros Acordo Parcelamentos</h4>
                                </div>
                            </div>
                            <div class="card-body">
                                <div>
                                </div>
                                <v-row>
                                </v-row>
                                <adm-data-table v-if="ListSinistros!=''" :headers="gridHeaders" :export-headers="headers"
                                    :filter-source-headers="filterHeaders" :filter-columns="4" :items="ListSinistros"
                                    v-model="itemsSelected" alternating theme-color="#364f66"
                                    table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina" file-name="parcelas-acordos"
>
                                    <template #item-entidadesResumo="item">
                                        <div class="gp-claim-entity-summary"><strong>{{ item.garNome || '—' }}</strong><small>{{ item.imoNome || '—' }}</small></div>
                                    </template>
                                    <template #item-pedDescricao="item">
                                        <div class="gp-claim-client-summary">
                                            <strong>{{ separarCliente(item.pedDescricao).nome }}</strong>
                                            <small v-if="separarCliente(item.pedDescricao).documento">{{ separarCliente(item.pedDescricao).documento }}</small>
                                        </div>
                                    </template>
                                    <template #item-sttDtVencimento="item">
                                        <span> {{ item.sttDtVencimento !== null ? formattedDate(item.sttDtVencimento) : null }}</span>
                                    </template>
                                    <template #item-sttValorPrincipal="item">
                                        <span> {{ item.sttValorPrincipal !== null ? formatarValor(item.sttValorPrincipal) : null }}</span>
                                    </template>
                                    <template #item-actions="item">
                                       <div class="gp-table-actions"><button type="button" class="gp-table-action gp-action-edit" title="Confirmar pagamento" v-if="item.stlId == 10" @click="ConfirmaPgto(item)"><v-icon size="17">mdi-cash</v-icon></button></div>
                                    </template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
          <v-dialog v-model="dialogPagamento" persistent class="gp-installment-dialog" transition="dialog-bottom-transition" max-width="680">
            <v-card class="gp-dialog-card">
                <v-card-title class="gp-dialog-title"><span><v-icon size="19">mdi-cash-check</v-icon> Confirmar pagamento</span><button type="button" class="gp-dialog-close" title="Fechar" @click.prevent="dialogPagamento = false"><v-icon size="18">mdi-close</v-icon></button></v-card-title>
                <v-card-text class="gp-dialog-content" v-if="itemAtual != ''">
                    <v-form>
                        <v-container>
                            <v-row>
                                 <v-col cols="12" md="12">
                                    <strong>Título: {{itemAtual.sttId }}</strong> -  {{ itemAtual.sttDescricao }}
                                </v-col>
                                <v-col cols="12" md="12">
                                    <strong>Cliente: {{itemAtual.pedDescricao }}</strong>
                                </v-col>
                                <v-col cols="12" md="6" style="padding-top: 25px;">
                                    <label>Valor Original</label>
                                    R$ {{ formatarValor(TituloPagamento.stpValorPrincipal) }}<br/>
                                     <label style="font-size: 20px !important;font-weight: 600;">Valor Total R$ {{ totalBR }}</label> 
                                </v-col>
                                 <v-col cols="12" md="3">
                                    <label>Valor Juros</label>
                                    <input v-model="TituloPagamento.stpValorJuro" v-decimal class="form-control"
                                        placeholder="Valor v" />
                                </v-col>
                                 <v-col cols="12" md="3">
                                    <label>Valor Mora</label>
                                    <input v-model="TituloPagamento.stpValorMora" v-decimal class="form-control"
                                        placeholder="Valor Mora" />
                                </v-col>
                                <v-col cols="12" md="6">
                                    <label>Pagamento</label>
                                    <input v-model="TituloPagamento.stpDtPagamento" type="date" class="form-control"
                                        placeholder="Data Pagamento" />
                                </v-col>
                                  <v-col cols="12" md="6">
                                    <label>Cód Pagamento</label>
                                    <input v-model="TituloPagamento.stpCodigoPagto" type="text" class="form-control"
                                        placeholder="Data Pagamento" />
                                </v-col>
                                <div class="col-md-12 col-lg-12" style="padding: 5px;">
                                    <div class="form-group">
                                        <label>Observações</label>
                                        <textarea cols="5" rows="3" style="width: 100%;" v-model="TituloPagamento.stpObservacao" class="form-control" maxlength="255"
                                            placeholder="Observações">
                                        </textarea>
                                    </div>
                                </div>
                                 <v-col cols="12" md="12">
                                        <label for="exampleFormControlFile1">*JPG, JPEG, PNG ou
                                            PDF</label>
                                        <v-file-input v-model="selectedFileDebito"
                                            label="Selecione o arquivo" variant="underlined"
                                            prepend-icon="mdi-file"
                                            accept="image/*,application/pdf"></v-file-input>
                                    </v-col>
                            </v-row>

                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions class="gp-dialog-actions">
                    <v-spacer></v-spacer>
                    <button type="button" class="gp-dialog-secondary" @click.prevent="dialogPagamento = false">Cancelar</button>
                    <button type="button" class="gp-dialog-primary" @click.prevent="AtualizaPagamento()"><v-icon size="15">mdi-content-save-outline</v-icon> Atualizar</button>
                </v-card-actions>
            </v-card>
        </v-dialog>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'

export default {
    name: 'ListaSinistrosAcordoParcelasView',
    components: {
        EasyDataTable,
        moment
    },
    data: () => ({
         User: {
            garid:0,
            tpeid:0,
        },
        itemsSelected: [],
        searchValue: '',
        MostraGrid: true,
        headers: [],
        ListSinistros:[],
        ListSinistrosGeral:[],
        itemAtual: [],
        dialogPagamento:false,
        TituloPagamento: {
            stpId: 0,
            sttId: 0,
            cusId: null,
            stpDtPagamento: null,
            stpValorPrincipal: 0,
            stpValorJuro: 0,
            stpValorMora: 0,
            stpValorTotal: 0,
            stpCodigoPagto: '',
            stpObservacao: ''
        },
        TituloPagamentoDocumento: {
            stdId: 0,
            stpId: null,
            cusId: null,
            stdDtInclusao: null,
            stdNomeOriginal: '',
            stdNomeInterno: '',
            docId: null
        }
    }),
    methods: {
        separarCliente(valor) {
            const texto = String(valor || '').trim();
            const partes = texto.split(' - ');
            if (partes.length < 2) return { nome: texto || '—', documento: '' };
            return { nome: partes.shift(), documento: partes.join(' - ') };
        },
        SelecionaSituacao(value){
            if (value > 0){          
                this.ListSinistros = this.ListSinistrosGeral.filter(x=> x.sstIdAtual == value);
            }
            else{
                this.ListSinistros = this.ListSinistrosGeral;
            }
          
        },
        onReady(editor)  {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        preprocessData(data) {
            return data.map(item => {
            return {
                ...item,
                proOrdem: parseInt(item.proOrdem),
            };
            });
        },
        formattedDate(value) {
            if (value!=null || value != ""){
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else{
                return "";
            }
           
        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        async UploadImg(value) {
            const formData = new FormData();
            formData.append('file', value);
            const uploadResult = await axios.post(`/Telas/ListaSinistrosAcordoParcelas/upload`, formData);
            return uploadResult;
        },
        buildFileUrl(path) {
            if (!path) return '';
            const rel = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/ListaSinistrosAcordoParcelas/GetFileByParam?param=${encodeURIComponent(rel)}`;
        },
        openInNewTab(path) {
            const url = this.buildFileUrl(path);
            if (!url) return;
            window.open(url, '_blank', 'noopener,noreferrer'); // nova aba
        },
        VisualizarDocumento(item) {
            if (item) {
                this.openInNewTab(item);
            }
        },
        montaGrid(){
            this.headers=[];
            this.headers.push({ text: "Título", value: "sttId", sortable: true, });
            this.headers.push({ text: "Contratacao", value: "pedId", sortable: true, });
            this.headers.push({ text: "Cliente", value: "pedDescricao", sortable: true, });
            if (this.User.garid == 0){
                this.headers.push({ text: "Garantidora", value: "garNome", sortable: true, });
            }
            if (this.User.tpeid != 3){
            this.headers.push({ text: "Imobiliaria", value: "imoNome", sortable: true, });
            }
            this.headers.push({ text: "Descrição", value: "sttDescricao", sortable: true, });
            this.headers.push({ text: "Valor", value: "sttValorPrincipal", sortable: true, });
            this.headers.push({ text: "Vencimento", value: "sttDtVencimento", sortable: true, });
             this.headers.push({ text: "Tipo", value: "mpgNome", sortable: true, });
            this.headers.push({ text: "Status", value: "stlNome", sortable: true, });
            this.headers.push({ text: 'Ações', value: 'actions' });
        },
        ConfirmaPgto(item) {
            item.sttDtVencimento = this.$moment(item.sttDtVencimento).format('YYYY-MM-DD')
            this.TituloPagamento.sttId = item.sttId;
            this.TituloPagamento.stpValorPrincipal = this.formatarValor(item.sttValorPrincipal);
            this.itemAtual = item;

            this.dialogPagamento = true;
        },
        async AtualizaPagamento() {
            if (!this.TituloPagamento.stpDtPagamento) {
            return this.$mensagemAviso("Selecione Data Pagamento");
            }

            // Leia como strings da UI e converta localmente
            const p = this.parseBR(this.TituloPagamento.stpValorPrincipal);
            const j = this.parseBR(this.TituloPagamento.stpValorJuro || '0');
            const m = this.parseBR(this.TituloPagamento.stpValorMora  || '0');
            const total =  Math.round((p + j + m) * 100) / 100;

            const payload = {
            // mantenha os ids/refs que precisa
            ...this.pickIds(this.TituloPagamento), // opcional: pegue só o que importa
            cusId: this.User.cusid,
            stpDtPagamento: this.$moment(this.TituloPagamento.stpDtPagamento)
                                .format('YYYY-MM-DDTHH:mm:ss'),
            stpValorPrincipal: p,
            stpValorJuro: j,
            stpValorMora: m,
            stpValorTotal: total
            };
             const resp = await axios.post('/Telas/ListaSinistrosAcordoParcelas/AddSinistroTituloPagamento', payload);
             const novoIdStpId = resp.data;

            //verifica se tem documentos
             if (novoIdStpId > 0) {
                 if (this.selectedFileDebito != '' && this.selectedFileDebito != null) {
                    try {
                        const uploadSuccess = await this.UploadImg(this.selectedFileDebito[0]);

                        if (uploadSuccess && uploadSuccess.data && uploadSuccess.data.nameFile) {
                            this.TituloPagamentoDocumento.stpId = novoIdStpId;
                            this.TituloPagamentoDocumento.cusId = this.User.cusid;
                            this.TituloPagamentoDocumento.stdDtInclusao = moment().format('YYYY-MM-DDTHH:mm:ss');
                            this.TituloPagamentoDocumento.stdNomeOriginal = this.selectedFileDebito[0].name;
                            this.TituloPagamentoDocumento.stdNomeInterno = uploadSuccess.data.nameFile;
                            this.TituloPagamentoDocumento.docId = 5;
                            await axios.post('/Telas/ListaSinistrosAcordoParcelas/AddSinistroTituloPagamentoDocumento', this.TituloPagamentoDocumento);
                            // Limpa seleções
                            this.selectedFileDebito = '';
                            this.dialogPagamento = false;
                            this.Get();
                        } else {
                            this.$mensagemErro("Erro inesperado ao processar o arquivo. Tente novamente.");
                        }
                    } catch (error) {
                        // Trata erro retornado pelo backend (ex: BadRequest)
                        const mensagem = error.response?.data || "Erro ao enviar o documento.";
                        this.$mensagemErro(mensagem);
                    }
                }
             }
             else{
                this.dialogPagamento = false;
                this.Get();
             }
        },
         pickIds(t) {
            // retorne apenas campos identificadores que o backend exige
            const { stpId, sttId,stpCodigoPagto,stpObservacao } = t || {};
            return { stpId, sttId,stpCodigoPagto,stpObservacao };
        },
        parseBR(v) {
            if (v === null || v === undefined || v === '') return 0;
            // remove pontos de milhar e troca vírgula por ponto
            return parseFloat(String(v).replace(/\./g, '').replace(',', '.')) || 0;
        },
        formatBR(n) {
            if (n === null || n === undefined || isNaN(n)) return '';
            return Number(n).toFixed(2).replace('.', ',');
        },
        async Get() {
              await axios.get(`/Telas/ListaSinistrosAcordoParcelas/GetDados`)
                .then(response => {
                    this.ListSinistrosGeral = response.data.sinistroTitulos.sort(
                        (a, b) => (b.sttDtVencimento || '').localeCompare(a.sttDtVencimento || '')
                        ).reverse();
                    this.ListSinistros = this.ListSinistrosGeral;
                    this.User.garid = response.data.garId;
                    this.User.tpeid = response.data.tpeId;
                    this.User.cusid = response.data.cusId;

                    //console.log('this.ListSinistrosGeral')
                    //console.log(this.ListSinistrosGeral)                
                    this.montaGrid();
                });           
          
        }
    },
    created() {
        this.Get();
    },
    computed: {
        filterHeaders() {
        const camposOcultos = ['sttDescricao', 'sttValorPrincipal', 'sttDtVencimento'];
        return this.headers.filter(header => !camposOcultos.includes(header.value));
        },
        gridHeaders() {
        const resultado = []; let entidadesIncluidas = false;
        this.headers.forEach(header => {
            if (header.value === 'garNome' || header.value === 'imoNome') {
                if (!entidadesIncluidas) { resultado.push({ text: 'Garantidora / Imobiliária', value: 'entidadesResumo', sortable: false }); entidadesIncluidas = true; }
            } else resultado.push(header);
        });
        return resultado;
        },
        totalRaw() {
        const p = this.parseBR(this.TituloPagamento.stpValorPrincipal);
        const j = this.parseBR(this.TituloPagamento.stpValorJuro);
        const m = this.parseBR(this.TituloPagamento.stpValorMora);
        return p + j + m;
        },
        totalBR() {
        return this.formatBR(this.totalRaw);
        }
    },
}
</script>

<style scoped>
  .tabinfo{
    font-size:14px;
    text-transform: capitalize;
  }
.gp-claim-entity-summary{display:flex;flex-direction:column;gap:2px;line-height:1.25}.gp-claim-entity-summary strong{color:#17223b;font-size:10.5px}.gp-claim-entity-summary small{color:#718096;font-size:9.5px}
.gp-installment-dialog :deep(.v-overlay__content){width:calc(100% - 28px)}
.gp-dialog-card{overflow:hidden;border:1px solid #e1d9cd!important;border-radius:14px!important;background:#fff!important;box-shadow:0 18px 50px rgba(16,42,90,.18)!important}
.gp-dialog-title{display:flex;align-items:center;justify-content:space-between;min-height:56px;padding:13px 18px!important;border-bottom:1px solid #e8e1d7;background:#fcfaf7!important;color:#102a5a}.gp-dialog-title>span{display:flex;align-items:center;gap:8px;font-size:14px;font-weight:800}.gp-dialog-title :deep(.v-icon){color:#d96f00}
.gp-dialog-close{display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border:1px solid #ddd6cc;border-radius:9px;background:#fff;color:#677386}
.gp-dialog-content{max-height:70vh;overflow-y:auto;padding:16px 18px!important;color:#4d586d}.gp-dialog-content :deep(.v-container){max-width:none;padding:0}.gp-dialog-content :deep(.v-row){margin:-6px}.gp-dialog-content :deep(.v-col){padding:6px;font-size:11.5px}.gp-dialog-content :deep(label){display:block;margin-bottom:5px;color:#3d485c;font-size:10.5px;font-weight:700}.gp-dialog-content :deep(.form-control),.gp-dialog-content :deep(.v-field){min-height:35px;border-radius:9px;font-size:11.5px}.gp-dialog-content :deep(textarea){resize:vertical}
.gp-dialog-actions{gap:8px;min-height:58px;padding:11px 18px!important;border-top:1px solid #e8e1d7;background:#fcfaf7}.gp-dialog-secondary,.gp-dialog-primary{display:inline-flex;align-items:center;justify-content:center;gap:5px;min-width:96px;min-height:34px;padding:7px 14px;border-radius:9px;font-size:11px;font-weight:700}.gp-dialog-secondary{border:1px solid #9ba4b0;background:#fff;color:#4f5b6d}.gp-dialog-primary{border:1px solid #e77900;background:#e77900;color:#fff}
@media(max-width:767.98px){.gp-dialog-content{max-height:72vh;padding:12px!important}.gp-dialog-actions{padding:10px 12px!important}.gp-dialog-secondary,.gp-dialog-primary{flex:1}}
</style>
